import { Component, OnInit } from '@angular/core';
import { BlockAbstractComponent } from '@gallaghercp/core-frontend';
import { APP_CONFIG } from '@core-app/app.config';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'core-block-card-callouts',
    templateUrl: './block-card-callouts.component.html',
    styleUrl: './block-card-callouts.component.scss',
    standalone: false,
})
export class BlockCardCalloutsComponent extends BlockAbstractComponent implements OnInit {
    cardImage: string | undefined;

    override ngOnInit() {
        if (environment.isLocalhost) {
            this.cardImage = APP_CONFIG.frontend + this.block.data.image_url;
        }
    }
}
